export const buildChangeProduct = (state, action) =>
  state.map((item) => {
    if (item.id === action.id) {
      return { ...item, ...action.obj };
    }
    return item;
  });
